import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { NRHandleEmptyCellValue } from '../CellComponent/CellComponent';
import { withCustomParams } from '../../NRReactGrid/withCustomParams';

const TooltipFormatter = ({ value, row, getCustomTooltipTitle }) => {
  return (
    <Tooltip
      enterTouchDelay={1500}
      followCursor={true}
      title={!!getCustomTooltipTitle ? getCustomTooltipTitle(row) : value?.length > 1 ? value : ''}
      placement={'top-start'}
    >
      <Box>
        <NRHandleEmptyCellValue value={value} />
      </Box>
    </Tooltip>
  );
};

export const TooltipProvider = ({ extraParams, ...props }) => {
  const customFormatter = withCustomParams(TooltipFormatter, extraParams);
  return <DataTypeProvider formatterComponent={customFormatter} {...props} />;
};
